import apiClient from './apiClient';

export interface MenuItem {
  code: string;
  label: string;
  route: string;
  desc: string;
}

export interface MenuResponse {
  items: MenuItem[];
  count: number;
}

export const pw9701Api = {
  async getMenu(): Promise<MenuResponse> {
    const res = await apiClient.get('/api/pw9701/menu');
    return res.data;
  },
};
